import { useState } from "react";
import axios from "axios"; // 1. Import Axios
import styles from "./Hero.module.scss";
import { Container } from "../Container/Container";
import { ReactComponent as SearchSvg } from "../../Images/Icons/search.svg";

const API_KEY = process.env.REACT_APP_WEATHER_API_KEY;

const Hero = ({ onSearch }) => {
  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const cityToSearch = inputValue.trim();

    if (!cityToSearch) return;

    setIsLoading(true);
    setError(null);

    try {
      const response = await axios.get(
        `https://api.openweathermap.org/data/2.5/weather?q=${cityToSearch}&appid=${API_KEY}`
      );

      if (response.status === 200) {
        onSearch(response.data.name);
        setInputValue("");
      }
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setError("City not found. Please try again.");
      } else {
        setError("Network error. Check connection.");
      }
    } finally {
      setIsLoading(false);
    }
  };

  const today = new Date();
  const monthYear = today.toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
  });
  const dayName = today.toLocaleDateString("en-US", {
    weekday: "long",
  });
  const getDayWithSuffix = (date) => {
    const day = date.getDate();
    if (day > 3 && day < 21) return `${day}th`;
    switch (day % 10) {
      case 1:
        return `${day}st`;
      case 2:
        return `${day}nd`;
      case 3:
        return `${day}rd`;
      default:
        return `${day}th`;
    }
  };
  const fullDayString = `${dayName}, ${getDayWithSuffix(today)}`;

  return (
    <div className={styles.hero}>
      <Container>
        <div className={styles["hero__container"]}>
          <h1 className={styles["hero__title"]}>Weather dashboard</h1>

          <div className={styles["hero__info"]}>
            <div
              className={`${styles["hero__text-block"]} ${styles["hero__text-block--left"]}`}
            >
              <p>
                Create your personal list of favorite cities and always be aware
                of the weather.
              </p>
            </div>
            <div className={styles["hero__separator"]}></div>
            <div className={`${styles["hero__text-block"]}`}>
              <p>{monthYear}</p>
              <p>{fullDayString}</p>
            </div>
          </div>

          <form className={styles["hero__search"]} onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Search location..."
              className={`${styles["hero__search-input"]} ${
                error ? styles["hero__search-input--error"] : ""
              }`}
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
                setError(null);
              }}
              disabled={isLoading}
              required
            />
            <button
              type="submit"
              className={styles["hero__search-btn"]}
              disabled={isLoading}
            >
              {isLoading ? (
                <span className={styles["hero__loader"]}></span>
              ) : (
                <SearchSvg className={styles["hero__search-icon"]} />
              )}
            </button>
            {error && <div className={styles["hero__error-msg"]}>{error}</div>}
          </form>
        </div>
      </Container>
    </div>
  );
};

export default Hero;
